import { CANCEL_ALL_TASKS_WS, CANCEL_ALL_TASKS_WS_SUCCESS, CANCEL_ALL_TASKS_WS_ERROR} from './actionTypes';

const initialState = {
    errorCancelAllTasksWs: "",
    loadingCancelAllTasksWs: false,
    successCancelAllTasksWs: ""
}

const cancelAllTasksWorkstations = (state = initialState, action) => {
    switch (action.type) {
        case CANCEL_ALL_TASKS_WS:
            state = {
                ...state,
                loadingCancelAllTasksWs: true
            }
            break;
        case CANCEL_ALL_TASKS_WS_SUCCESS:
            state = {
                ...state,
                loadingCancelAllTasksWs: false,
                successCancelAllTasksWs: action.payload.message
            }
            break;
        case CANCEL_ALL_TASKS_WS_ERROR:
            state = { ...state, errorCancelAllTasksWs: action.payload, loadingCancelAllTasksWs: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default cancelAllTasksWorkstations;